module.exports = __webpack_public_path__ + "static/loader-logo-eb479580a0fa2f43e80e8c36ce724c45.png";